/**
 * Une écriture du dashboard invalide le cache côté back, qui rediffuse un
 * `dashboard-invalidated` par Ably — y compris à l'onglet qui vient d'écrire.
 * Or celui-ci rafraîchit déjà ses données : la notif « De nouvelles données sont
 * disponibles » n'y a aucun sens. L'appelant ouvre donc une fenêtre de grâce
 * autour de ses écritures, l'invalidation arrivant de façon asynchrone.
 *
 * Même mécanique que `reloadSuppressed()` du moteur de tuto (`lib/tourEngine`),
 * pour la même raison. La fenêtre reste courte : pendant ce laps, l'écriture
 * d'un AUTRE utilisateur serait avalée elle aussi.
 */
const GRACE_MS = 5000;

let suppressedUntil = 0;

export function suppressDashboardReloadNotice(ms: number = GRACE_MS): void {
  suppressedUntil = Math.max(suppressedUntil, Date.now() + ms);
}

export function dashboardReloadNoticeSuppressed(): boolean {
  return Date.now() < suppressedUntil;
}
